import { render } from "./ModalHistoryContent.vue?vue&type=template&id=e51ae104"
import script from "./ModalHistoryContent.vue?vue&type=script&lang=js"
export * from "./ModalHistoryContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__